import axiosClient from '@aspida/axios';
import { configuredAxiosClient } from './configuredAxiosClient';
import api from '~/apis/AutogenTimeeApiClient/admin/$api';

export const aspidaClient = api(axiosClient(configuredAxiosClient()));
